/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depending on your jurisdiction, you may have the right to:`)
};

const es_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dependiendo de tu jurisdicción, puedes tener derecho a:`)
};

const de_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je nach Ihrer Rechtsordnung haben Sie möglicherweise das Recht auf:`)
};

const nl_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afhankelijk van uw rechtsgebied heeft u mogelijk het recht om:`)
};

const fr_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selon votre juridiction, vous pouvez avoir le droit de :`)
};

const it_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A seconda della tua giurisdizione, potresti avere il diritto di:`)
};

const pt_br2_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dependendo da sua jurisdição, você pode ter o direito de:`)
};

const pt_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dependendo da sua jurisdição, pode ter o direito de:`)
};

const ja_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お住まいの地域によっては、以下の権利を有する場合があります:`)
};

const zh_privacy_section_8_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据您所在的司法管辖区，您可能有权：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_8_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_8_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_8_intro", locale)
	if (locale === "en") return en_privacy_section_8_intro(inputs)
	if (locale === "es") return es_privacy_section_8_intro(inputs)
	if (locale === "de") return de_privacy_section_8_intro(inputs)
	if (locale === "nl") return nl_privacy_section_8_intro(inputs)
	if (locale === "fr") return fr_privacy_section_8_intro(inputs)
	if (locale === "it") return it_privacy_section_8_intro(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_8_intro(inputs)
	if (locale === "pt") return pt_privacy_section_8_intro(inputs)
	if (locale === "ja") return ja_privacy_section_8_intro(inputs)
	return zh_privacy_section_8_intro(inputs)
};